import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../../../lib/api";
import { circlesQueryKey, dailyGoalsQueryKey } from "../constants";

export function useGoalsData() {
  const goalsQuery = useQuery({
    queryKey: dailyGoalsQueryKey,
    queryFn: () => apiClient.getDailyGoals(),
  });

  const circlesQuery = useQuery({
    queryKey: circlesQueryKey,
    queryFn: () => apiClient.getCircles(),
  });

  const activeGoals = useMemo(
    () => goalsQuery.data?.filter((goal) => goal.active) ?? [],
    [goalsQuery.data],
  );
  const circleNameById = useMemo(
    () => new Map((circlesQuery.data ?? []).map((circle) => [circle.id, circle.name])),
    [circlesQuery.data],
  );

  return {
    activeGoals,
    circleNameById,
    circles: circlesQuery.data,
    circlesQuery,
    goalsQuery,
  };
}
